import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApplicationDataService } from '../../../../services/application.service';
import { Property } from '../../../models/property';
import { AddApplicant } from '../../../models/addapplicant';
import { Application } from '../../../models/application';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { ErrorService } from 'services/error.service';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { DuplicateAppDialogComponent } from './duplicate-app-dialog/duplicate-app-dialog.component';
import { TrackingParameters } from 'app/models/tracking-parameter';
import { AnalyticsService } from 'services/analytics.service';

@Component({
  selector: 'app-additional-property',
  templateUrl: './additional-property.component.html',
  styleUrls: ['./additional-property.component.css']
})
export class AdditionalPropertyComponent implements OnInit {
  myControl = new FormControl();
  model: any[];
  properties: Property[];
  results: Property[];
  selectedProperty: Property = new Property();
  isValid = false;
  applicants: AddApplicant[];
  ShowNoApplicantMsg = false;
  displayDuplicateAppMsg = false;
  source: string = null;
  campaign: string = null;
  adgroup: string = null;
  keyword: string = null;
  adcopy: string = null;
  device: string = null;
  medium: string = null;
  options: string[] = [];
  filteredOptions: Observable<string[]>;
  trackingParams: TrackingParameters;

  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  coApplicantCtrl = new FormControl();
  filteredCoApplicants: Observable<string[]>;
  coApplicants: string[] = [];
  allCoApplicants: string[] = [];
  @ViewChild('coApplicantInput') coApplicantInput: ElementRef<HTMLInputElement>;

  constructor(
    private applicationService: ApplicationDataService,
    private router: Router,
    private errorService: ErrorService,
    public dialog: MatDialog,
    private readonly analyticsService: AnalyticsService) {
    this.analyticsService.track(
      'HRA Application',
      'Additional Property',
      'Start',
      'Start',
      '',
      this.additionalAnalyticsDetails());
      this.filteredCoApplicants = this.coApplicantCtrl.valueChanges.pipe(
      startWith(''),
      map((coApplicant: string | null) => coApplicant ? this._filterCoApplicants(coApplicant) : this.allCoApplicants.slice()));

      this.properties = [];
      this.applicationService.getProperties()
        .subscribe(res => this.onGetProperties(res.results), err => this.applicationService.handleError(err));
   }

  private additionalAnalyticsDetails(): any {
    try {
      return {
        'Source': this.source,
        'Campaign': this.campaign,
        'Adgroup': this.adgroup,
        'Medium': this.medium,
        'Keyword': this.keyword,
        'Adcopy': this.adcopy,
        'Device': this.device,
       };
    } catch (error) {
      console.error(error);
      return {};
    }
  }

   add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {

      if (!this.coApplicants.includes(value.trim()))
      {
        this.coApplicants.push(value.trim());
      }
    }

    if (input) {
      input.value = '';
    }

    this.coApplicantCtrl.setValue(null);
  }
  

  remove(value: string): void {
    const index = this.coApplicants.indexOf(value);

    if (index >= 0) {
      this.coApplicants.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    let index =   this.coApplicants.indexOf(event.option.viewValue);
     if(index == -1){
        this.coApplicants.push(event.option.viewValue);
      }
    this.coApplicantInput.nativeElement.value = '';
    this.coApplicantCtrl.setValue(null);
  }

  private _filterCoApplicants(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.allCoApplicants.filter(coApplicant => coApplicant.toLowerCase().indexOf(filterValue) === 0);
  }

   onGetProperties(properties: Property[]) {
    this.properties = properties;
    
    for (const prop of this.properties) {
      this.options.push(prop.title);
    }

    localStorage.setItem('Waitlist', JSON.stringify(properties));
   }

   search(event) {
     if (this.properties.length > 0) {
        this.results = this.properties.filter(
          prop => prop.title.toLowerCase().indexOf(event.query.toLowerCase()) >= 0
        );
      }

   }

   onSelect(value: string) {
     this.selectedProperty = this.properties.find(x => x.title === value);
     this.applicationService.getApplicantApplicationForProperty(this.selectedProperty.unit_code)
     .subscribe(res => this.onApplicationCheck(res), err => this.errorService.showError(err));
   }

  ngOnInit() {

    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );

      

    this.applicants = [];
    this.applicationService.getPreviousAdditionalRentalApplicants()
    .subscribe(res => this.onGetAdditionalApplicants(res), err => this.applicationService.handleError(err));

    let trackingParams = localStorage.getItem('TrackingParameters');

    if (trackingParams)
    {
      this.trackingParams = JSON.parse(trackingParams);
      
      this.source = this.trackingParams.Source;
      this.campaign = this.trackingParams.Campaign;
      this.adgroup = this.trackingParams.AdGroup;
      this.medium = this.trackingParams.Medium;
      this.keyword = this.trackingParams.Keyword;
      this.adcopy = this.trackingParams.AdCopy;
      this.device = this.trackingParams.Device;
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }

  onGetAdditionalApplicants(applicants: AddApplicant[]) {
    
    for (const a of applicants)
    {
      const applicant = new AddApplicant();
      applicant.FirstName = a.FirstName;
      applicant.LastName = a.LastName;
      applicant.FullName = a.FirstName + ' ' + a.LastName;
      applicant.Email = a.Email;
      applicant.RentalApplicantKey = a.RentalApplicantKey;
      this.applicants.push(applicant);
      this.coApplicants.push(applicant.FullName);
      this.allCoApplicants.push(applicant.FullName);
    }

    if (applicants.length === 0) {
      this.ShowNoApplicantMsg = true;
    }
  }

  onApplicationCheck(application: Application) {
    if (application) {
      this.displayDuplicateAppMsg = true;
      const dialogConfig = new MatDialogConfig();
      application.Property.AddressLine1 = this.selectedProperty.title;
      dialogConfig.width = "300px";
      dialogConfig.data = application;

      let dialogRef = this.dialog.open(DuplicateAppDialogComponent, dialogConfig);

      dialogRef.afterClosed().subscribe(result => {
        if(result == "yes"){
          this.cancelExistingApplication(application.YardiKey, dialogRef);
        }
      });
    }
  }

  cancelExistingApplication(yardiKey: string, dialogRef: MatDialogRef<DuplicateAppDialogComponent, any>) {
    this.applicationService.cancelExistingApplication(yardiKey).subscribe(res => { this.onSubmit(); dialogRef.close();}, err => this.errorService.showError(err));
  }

  onSubmit() {
    this.applicants = this.applicants.filter(applicant => this.coApplicants.includes(applicant.FullName));
    this.applicationService.addAdditionalProperty(this.selectedProperty, this.applicants, this.source, this.campaign, this.adgroup, this.keyword, this.adcopy, this.device, this.displayDuplicateAppMsg, this.medium)
    .subscribe(res => this.handleResponse(res), err => this.applicationService.handleError(err));
  }

  handleResponse(app: Application) {
    if (app.RentalApplicationKey)
    {
      localStorage.removeItem('SelectedProperty');
      localStorage.setItem('RentalApplicationKey', app.RentalApplicationKey.toString());
      localStorage.setItem('RentalApplicantKey', app.PrimaryRentalApplicantKey.toString());
      localStorage.setItem('YardiKey', app.YardiKey);
      this.analyticsService.track(
        'HRA Application',
        'Additional Property',
        'Stop',
        'Sending to basic',
        '/application/basic',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/basic']);
    }
    else {
      this.errorService.showError("Error adding property.");
    }
    
  }
}
